export const contacts = {
  phone: '(408) 889-7521',
  email: 'info@rmachine.org',
  address: 'San Francisco Bay Area, CA',
  workingHours: 'Monday – Sunday: 7am – 9pm',
};
